import { Check, ShieldCheck } from '@phosphor-icons/react';
import { vars, Column, Inline, Stack, breakpoints, Columns, Text, textVariants } from '@etg/wings';
import { css, cx } from '@eti/styles';
import type { ReactNode } from 'react';

const uspItemWrapperStyles = css`
  align-items: flex-start;
  display: flex;
  gap: 8px;
  text-align: start;
`;

interface UniqueSellingPointProps {
  className?: string;
  icon: ReactNode;
  isBold?: boolean;
  title: string;
}

const UniqueSellingPoint = ({
  className,
  icon,
  isBold = false,
  title,
}: UniqueSellingPointProps) => (
  <div className={cx(uspItemWrapperStyles, className)}>
    {icon}
    <Stack spacing={4}>
      {title && (
        <Text as="p" variant={isBold ? textVariants._14_BOLD : textVariants._14}>
          {title}
        </Text>
      )}
    </Stack>
  </div>
);

const shieldStyles = css`
  justify-content: start;

  @media (min-width: ${breakpoints._560}) {
    justify-content: end;
  }
`;

interface SubUniqueSellingPointProps {
  titles: {
    firstTitle: string;
    secondTitle: string;
    thirdTitle: string;
  };
}

const SubUniqueSellingPoint = ({ titles }: SubUniqueSellingPointProps) => {
  const { firstTitle, secondTitle, thirdTitle } = titles;
  const iconColor = vars.colors.signal.positive.light;

  return (
    <Columns data-testid="protect-usp" spacing={8}>
      <Column width={{ [breakpoints._0]: '4/4' }}>
        <UniqueSellingPoint
          className={shieldStyles}
          icon={
            <ShieldCheck
              aria-hidden
              color={iconColor}
              data-testid="shield-check-icon"
              size={22}
              weight="duotone"
            />
          }
          isBold
          title={firstTitle}
        />
      </Column>
      <Column>
        <Inline
          align="end"
          collapseBelow={breakpoints._560}
          noWrap
          spacing={{
            [breakpoints._0]: 16,
            [breakpoints._768]: 32,
          }}
        >
          <UniqueSellingPoint
            icon={
              <Check
                aria-hidden
                color={iconColor}
                data-testid="check-icon"
                size={20}
                weight="light"
              />
            }
            title={secondTitle}
          />
          <UniqueSellingPoint
            icon={
              <Check
                aria-hidden
                color={iconColor}
                data-testid="check-icon"
                size={20}
                weight="light"
              />
            }
            title={thirdTitle}
          />
        </Inline>
      </Column>
    </Columns>
  );
};

export default SubUniqueSellingPoint;
